/**
 * This is a wrapper around wagmi's useConnect hook that adds some
 * additional functionality.
 */

import {
  type UseConnectParameters,
  useConnect as wagmiUseConnect,
  CreateConnectorFn,
  Connector,
} from "wagmi";
import { logger } from "../../logger";

export function useConnect({ ...props }: UseConnectParameters = {}) {
  const { connect, connectAsync, connectors, ...rest } = wagmiUseConnect({
    ...props,
    mutation: {
      ...props.mutation,
      onError(err) {
        if (err.message) {
          if (err.message !== "User rejected request") {
            logger.error(`${err.message}: ${err}`);
          }
        } else {
          logger.error(`Could not connect: ${err}`);
        }
      },
    },
  });

  return {
    connect: ({
      connector,
      chainId,
      mutation,
    }: {
      connector: CreateConnectorFn | Connector;
      chainId?: number;
      mutation?: UseConnectParameters["mutation"];
    }) => {
      return connect(
        {
          connector,
          chainId,
        },
        mutation,
      );
    },
    connectAsync: async ({
      connector,
      chainId,
      mutation,
    }: {
      connector: CreateConnectorFn | Connector;
      chainId?: number;
      mutation?: UseConnectParameters["mutation"];
    }) => {
      return connectAsync(
        {
          connector,
          chainId,
        },
        mutation,
      );
    },
    connectors,
    ...rest,
  };
}
